<div class="area-list">
    <div class="user-management-heading-info">
       <div class="align-h width-stretch">
          <div class="stretch">Department Name</div>
          <div class="form-group stretch">
             <mat-form-field>
                <input placeholder="Search by Department Name" matInput [(ngModel)]="searchByName" name="search" #search="ngModel">
                <mat-icon matSuffix>search</mat-icon>
             </mat-form-field>
          </div>
          <div class="margin-right-10"></div>
       </div>
    </div>
    <ng-template ngFor let-department [ngForOf]="departmentList | searchFilter: ['name']:searchByName">
       <div class="align-h width-stretch margin-bottom-20 area-list-layout">
          <div class="stretch margin-left-15">{{ department.name }}</div>
          <div class="align-h width-215">
             <div class="stretch">
                <a
                   mat-flat-button
                   (click)="$event.stopPropagation();onEditDepartment(department)"
                   >
                <img
                   src="assets/images/Edit.png"
                   alt="Edit"
                   >
                </a>
             </div>
             <div class="stretch">
                <a 
                   mat-flat-button
                   (click)="$event.stopPropagation();openDeleteDialog(department)"
                   >
                <img
                   src="assets/images/Delete.png"
                   alt="Delete"
                   >
                </a>
             </div>
          </div>
       </div>
    </ng-template>
    <div class="no-data" *ngIf="(departmentList | searchFilter:['name']:searchByName)?.length === 0 ">No data found!!!</div>
 </div>